export var ActiveServicesReportOptionalColumns = /*#__PURE__*/ function(ActiveServicesReportOptionalColumns) {
    ActiveServicesReportOptionalColumns["ServiceName"] = "Service";
    ActiveServicesReportOptionalColumns["CustomerName"] = "Company";
    ActiveServicesReportOptionalColumns["Trigger"] = "Trigger";
    ActiveServicesReportOptionalColumns["Pricing"] = "Pricing";
    ActiveServicesReportOptionalColumns["Occurrence"] = "Occurrence";
    ActiveServicesReportOptionalColumns["Rate"] = "Rate";
    ActiveServicesReportOptionalColumns["LastBilled"] = "Last billed";
    ActiveServicesReportOptionalColumns["Assignee"] = "Assignee";
    ActiveServicesReportOptionalColumns["AutomaticServiceState"] = "Automatic service state";
    ActiveServicesReportOptionalColumns["Status"] = "Status";
    return ActiveServicesReportOptionalColumns;
}({});
export var FilterType = /*#__PURE__*/ function(FilterType) {
    FilterType["CustomerName"] = "company";
    FilterType["AgreementName"] = "agreement";
    FilterType["ServiceName"] = "service";
    FilterType["Occurrence"] = "occurrence";
    FilterType["Trigger"] = "trigger";
    FilterType["Pricing"] = "pricing";
    FilterType["LastBilled"] = "lastBilled";
    FilterType["Assignee"] = "assignee";
    FilterType["AutomaticServiceState"] = "automaticServiceState";
    FilterType["Status"] = "status";
    return FilterType;
}({});
